export default function RunnerShoppingFixedCounter(props: { value: number; label: string }) {
  return (
    <div className={`RunnerShoppingCart w-[84px] self-start relative`}>
      <div className='absolute top-0 left-0 w-full h-full bg-secondary rounded-20' />
      <div className='relative w-full rounded-16 p-2'>
        <div className='relative text-body-s grid overflow-hidden text-center'>
          <div
            className={`col-start-1 col-span-1 row-start-1 row-span-1 px-14 pt-10 transition-transform duration-700 ease-out-back`}
          >
            {props.label}
          </div>
        </div>

        <div className={`relative text-numbers text-24 rounded-16 text-center border-2 border-dark-cream`}>
          <div className='relative py-5 px-6 overflow-hidden rounded-16'>
            <div
              className={`absolute top-0 left-0 w-full h-full bg-cream transition-colors duration-500 ease-out-quad`}
            />
            <div className='relative z-1'>$ {props.value}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
